import { render } from "./BillboardMap.vue?vue&type=template&id=223b6e8e"
import script from "./BillboardMap.vue?vue&type=script&lang=js"
export * from "./BillboardMap.vue?vue&type=script&lang=js"

import exportComponent from "/builds/benoit67/page-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__